"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Google2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Google"));
var _ColoredFacebook2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ColoredFacebook"));
var _Apple2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Apple"));
var _reactIntl = require("react-intl");
var _jsxRuntime = require("react/jsx-runtime");
var _ColoredFacebook, _Google, _Apple;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var SocialButtonType = /*#__PURE__*/function (SocialButtonType) {
  SocialButtonType["facebook"] = "facebook";
  SocialButtonType["google"] = "google";
  SocialButtonType["apple"] = "apple";
  return SocialButtonType;
}(SocialButtonType || {});
const getIcon = buttonType => {
  switch (buttonType) {
    case "facebook":
      return _ColoredFacebook || (_ColoredFacebook = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ColoredFacebook2.default, {}));
    case "google":
      return _Google || (_Google = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Google2.default, {}));
    case "apple":
      return _Apple || (_Apple = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Apple2.default, {}));
    default:
      return null;
  }
};
const getProvider = buttonType => {
  switch (buttonType) {
    case "facebook":
      return "Facebook";
    case "google":
      return "Google";
    case "apple":
      return "Apple";
    default:
      return "";
  }
};
const CustomSocialButton = _ref => {
  let {
    id,
    buttonType,
    onClick,
    dataTest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
    type: "secondary",
    id: id,
    fullWidth: true,
    centered: true,
    iconLeft: getIcon(buttonType),
    onClick: onClick,
    dataTest: dataTest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "account.log_in_with",
      values: {
        provider: getProvider(buttonType)
      }
    })
  });
};
var _default = exports.default = CustomSocialButton;